import { render, staticRenderFns } from "./Dependency.vue?vue&type=template&id=26741ed2&scoped=true"
import script from "./Dependency.vue?vue&type=script&lang=js"
export * from "./Dependency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26741ed2",
  null
  
)

export default component.exports